export default __webpack_public_path__ + "static/media/illustration-woman-online-mobile.0ec5a893.svg";